<div class="flex flex-col sm:flex-row gap-2 text-sm p-2">
  @if(showInfo){
  <div class="text-dc-navy font-semibold">
    {{ "PAGINATION.INFO" | translate : data }}
  </div>
}
  @if (data?.totalPages && data.totalPages > 1) {
  <div class="flex gap-2 md:ltr:ml-auto md:rtl:mr-auto">
    <!-- Prev -->
    <button
      type="button"
      (click)="prevPage()"
      [disabled]="data.currentPage === 1"
      class="py-1 text-dc-navy font-semibold disabled:opacity-50"
    >
      <i class="fas fa-angle-left px-2 transition-transform rtl:rotate-180"></i>
      {{ "PAGENATION.PRE" | translate }}
    </button>
    @for (pg of displayPages; track pg) { @if ( typeof pg === 'number') {
    <button
      type="button"
      [ngClass]="{
        'text-dc-navy font-semibold': data.currentPage == pg,
        'text-dc-gray-light': data.currentPage != pg
      }"
      class="py-1 cursor-pointer"
      [disabled]="pg === data.currentPage"
      (click)="goToPage(pg)"
    >
      {{ pg }}
    </button>
    } @else {
    <span
      class="px-2 text-dc-gray-light cursor-pointer"
      (click)="handlePageClick(pg)"
      >…</span
    >
    } }
    <!-- Next  -->
    <button
      type="button"
      (click)="nextPage()"
      [disabled]="data.currentPage === data.totalPages"
      class="py-1 text-dc-navy disabled:opacity-50 font-semibold"
    >
      {{ "PAGENATION.NEXT" | translate }}
      <i
        class="fas fa-angle-right px-2 transition-transform rtl:rotate-180"
      ></i>
    </button>
  </div>
  }
</div>
